import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import SelectCard from "../../modals/SwiperModal/SelectCard";
import useCurrentUserData from "../../hooks/useCurrentUserData";
import models from "../../types/models";
import "./style.scss";
import { demonstrationStore } from "../../store/Demonstration";
import { observer } from "mobx-react-lite";
import useModalActions from "../../hooks/useModalActions";
import { MODAL_TYPES } from "../../utils/emitter";
import usePwaPopup from "../../hooks/usePwaPopup";
import game from "../../store/Game";
import PersonalAccount from "../../store/PersonalAccount";
import { isPWA } from "../../utils/helpers";
import config from "../../config";

export default observer(function GridCard({
  card,
  openCard,
  type,
  selectCard,
  id,
  isDemonstrationActiveCard,
  gameId,
}) {
  GridCard.propTypes = {
    card: PropTypes.oneOfType([
      models.gameMatch,
      models.marathonCard,
      models.gameTestResult,
    ]),
    openCard: PropTypes.func,
    type: PropTypes.oneOf(["select", "default"]),
    id: PropTypes.string,
    selected: PropTypes.bool,
    isDemonstrationActiveCard: PropTypes.bool,
    selectCard: PropTypes.func,
    gameId: PropTypes.number,
  };
  const { openPwaModal } = usePwaPopup();

  const { isCurrentUserMale } = useCurrentUserData();

  const refCard = useRef();

  useEffect(() => {
    if (isDemonstrationActiveCard) {
      demonstrationStore.setRefCard(refCard);
    }
  }, [isDemonstrationActiveCard]);

  const manageNameCard = (card) => {
    if (card.question) {
      return card.question;
    }
    if (isCurrentUserMale()) {
      return card.question_for_male;
    }
    return card.question_for_female;
  };
  return (
    <div
      id={id}
      ref={refCard}
      style={isDemonstrationActiveCard ? { zIndex: 1000 } : null}
      className={`match-card ${type === "select" && "match-card-select"}`}
    >
      {(type === "select" || demonstrationStore.isOpen) && (
        <SelectCard
          size="small"
          onClick={() => selectCard(card)}
          selected={
            (card?.selected || card?.isCheckedZone) &&
            !demonstrationStore.isOpen
          }
        />
      )}
      {!!card?.newMatch && <div className="match-card__new-match" />}
      <img
        onClick={() => {
          if (!isPWA()) {
            PersonalAccount.getPersonalAccountData();
            const isOpened = openPwaModal(gameId);
            if (!isOpened) openCard();
            return;
          }
          openCard();
        }}
        className={`match-card__img ${
          (card.selected || card?.isCheckedZone) &&
          !demonstrationStore.isOpen &&
          "match-card__img_selected"
        }`}
        src={
          card?.cardUrl
            ? `${config.staticApiUrl}${card?.cardUrl}`
            : card.src
        }
        alt="match-card"
      />
      <div className="match-card__card-name">{manageNameCard(card)}</div>
    </div>
  );
});
